import FontAwesomeIcon from '../../../helpers/fontawesome/fontAwesome'
import React, { useContext } from 'react'
import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import AppContext from '../../../context/Context'

const getVisiblePages = (currentPage, lastPage) => {
    if (lastPage <= 4) {
        return Array.from({ length: lastPage }, (_, index) => index + 1);
    }

    if (currentPage <= 3) {
        return [1, 2, 3, 4, 'end-ellipsis', lastPage];
    }

    if (currentPage >= lastPage - 2) {
        return [1, 'start-ellipsis', lastPage - 3, lastPage - 2, lastPage - 1, lastPage];
    }

    return [1, 'start-ellipsis', currentPage - 1, currentPage, currentPage + 1, 'end-ellipsis', lastPage];
};

const Pagination = ({ prevPage, nextPage, goToPage, meta }) => {
    const { isRTL } = useContext(AppContext);

    const { currentPage, lastPage } = meta;
    const current = Number(currentPage);
    const last = Number(lastPage);
    const visiblePages = getVisiblePages(current, last);

    return <>
        <Button type="button" data-testid="prevButton" color="falcon-default" size="sm" className="ml-1 ml-sm-2" onClick={prevPage} disabled={(current <= 1)}>
            <FontAwesomeIcon icon={`chevron-${isRTL ? 'right' : 'left'}`} />
        </Button>

        {visiblePages.map((page, index) => {
            if (typeof page === 'string') {
                return (
                    <span className="ml-2 text-muted" key={`${page}-${index}`} aria-hidden="true">
                        ...
                    </span>
                );
            }

            return (
                <Button
                    type="button"
                    data-testid="pagination-item"
                    color={current === page ? 'falcon-primary' : 'falcon-default'}
                    size="sm"
                    className="ml-2"
                    onClick={() => goToPage(page)}
                    key={page}
                >
                    {page}
                </Button>
            );
        })}

        <Button type="button" data-testid="nextButton" color="falcon-default" size="sm" className="ml-1 ml-sm-2" onClick={nextPage} disabled={(current === last)}>
            <FontAwesomeIcon icon={`chevron-${isRTL ? 'left' : 'right'}`} />
        </Button>
    </>
}

Pagination.propTypes = {
    meta: PropTypes.object.isRequired,
    nextPage: PropTypes.func.isRequired,
    prevPage: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired
}

export default Pagination;